<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px">
    <template
      v-slot:activator="{ on }">
      <v-text-field
        v-model="data[modifyIndex].dob"
        label="Date of Birth"
        prepend-icon="event"
        readonly
        v-on="on"></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      v-model="data[modifyIndex].dob"
      :max="new Date().toISOString().substr(0, 10)"
      min="1900-01-01">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    data: Array,
    modifyIndex: Number
  },
  mounted () {

  },
  methods: {

  },
  data: () => ({
    date: null,
    menu: false
  }),
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
    ])
  }
};
</script>
<style>
.condCard {
  padding: 20px;
  margin: 5px;
}
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
